import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withRouter } from "../../../helpers/withRouter"

//i18n
import { withTranslation } from "react-i18next"
// users
import user1 from "../../../assets/images/users/icons8.png"

import {
  getItemFromLocalStorage,
  clearValuesOnLogout,
} from "../../../helpers/utils"
import { Message } from "../../../helpers/language_helper"

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "Admin",
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  componentDidMount() {}

  HandleLogout = () => {
    // sessionStorage.clear()
    clearValuesOnLogout()
    window.location.reload()
    // this.props.history.push("/")
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle font-size-200 header-profile-user"
              src={user1}
              alt="Header Avatar"
            />
            <span className="d-none d-xl-inline-block ms-2 me-1">
              {getItemFromLocalStorage("user_name")}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem tag="a" onClick={this.HandleLogout}>
              <i className="bx bx-power-off font-size-16 align-middle me-2 text-danger" />
              <span>{Message("Logout")}</span>
            </DropdownItem>
            <DropdownItem tag="a" href="/change-password">
              <i className="fa fa-key  font-size-14 align-middle me-2 text-danger"></i>
              <span>{Message("changePassword")}</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu))
